// import React from 'react';
// import './feature.css';

// const Blog = () => {
//   // Service tasks defined for each card
//   const serviceTasks = {
//     brandIdentity: [
//       "Naming",
//       "Logo ",
//       "Visual Identity",
//       "Positioning",
//       "Creative Direction",
//       "Verbal Identity"
//     ],
//     uiuxDesign: [
//       "User Research",
//       "Website Creation",
//       "UI/UX ",
//       "Customer Experience (CX)",
//       "Prototyping and Testing",
//       "Design Sprint"
//     ],
//     webDevelopment: [
//       "Team Training ",
//       "Design Workshop",
//       "Marketing Workshop",
//       "Brand Positioning"
//     ],
//     communicationStrategy: [
//       "Content Strategy",
//       "Copywriting",
//       "Campaign Design",
//       "Social Media Marketing",
//       "Video Creation",
//       "Brand Storytelling"
//     ]
//   };

//   return (
//     <div className="cards-container">
//       <div className="ulev__blog-content">
//         <h1>What we Do</h1>
//       </div>
//       <div className="cards">
//         <div className="card-header">
//           <div className="card-content">
//             <div className="card-title">01</div>
//             <div className="card-description">BRAND STRATEGY</div>
//           </div>
//           <div className="card-tasks">
//             <ul>
//               {serviceTasks.brandIdentity.map((task, index) => (
//                 <li key={index}>{task}</li>
//               ))}
//             </ul>
//           </div>
//           <img src="https://i.postimg.cc/Bq8Z0srF/Brand-Identity-1.avif" alt="Brand Identity" className="card-image" />
//         </div>
//         <div className="card-header">
//           <div className="card-content">
//             <div className="card-title">02</div>
//             <div className="card-description">EXPERIENCE DESIGN</div>
//           </div>
//           <div className="card-tasks">
//             <ul>
//               {serviceTasks.uiuxDesign.map((task, index) => (
//                 <li key={index}>{task}</li>
//               ))}
//             </ul>
//           </div>
//           <img src="https://i.postimg.cc/w9FvcwpW/UI-UX-1.avif" alt="UI/UX Design" className="card-image" />
//         </div>
//         <div className="card-header">
//           <div className="card-content">
//             <div className="card-title">03</div>
//             <div className="card-description">BRAND CONSULTING</div>
//           </div>
//           <div className="card-tasks">
//             <ul>
//               {serviceTasks.webDevelopment.map((task, index) => (
//                 <li key={index}>{task}</li>
//               ))}
//             </ul>
//           </div>
//           <img src="https://i.postimg.cc/c0t18d9L/Web-Development-1.avif" alt="Web Development" className="card-image" />
//         </div>
//         <div className="card-header">
//           <div className="card-content">
//             <div className="card-title">04</div>
//             <div className="card-description">COMMUNICATION / VERBAL DESIGN</div>
//           </div>
//           <div className="card-tasks">
//             <ul>
//               {serviceTasks.communicationStrategy.map((task, index) => (
//                 <li key={index}>{task}</li>
//               ))}
//             </ul>
//           </div>
//           <img src="https://i.postimg.cc/nnn5fkDf/Communication-Strategy-1.avif" alt="Communication Strategy" className="card-image" />
//         </div>
//       </div>
//     </div> 
//   );
// };

// export default Blog;








import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase';
import './feature.css';

const Blog = () => {
  const [services, setServices] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const docRef = doc(db, 'siteSettings', 'content');
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.services) {
            setServices(data.services);
          } else {
            setError('Services data not found in document');
          }
        } else {
          setError('Document not found');
        }
      } catch (err) {
        console.error('Error fetching services:', err);
        setError('Failed to load services');
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return (
      <div className="cards-container">
        <div className="ulev__blog-content">
          <h1>What we Do</h1>
        </div>
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading services...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cards-container">
        <div className="ulev__blog-content">
          <h1>What we Do</h1>
        </div>
        <div className="error-message">
          <p>Error: {error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    );
  }

  if (!services) {
    return (
      <div className="cards-container">
        <div className="ulev__blog-content">
          <h1>What we Do</h1>
        </div>
        <p>No services data available</p>
      </div>
    );
  }

  // Convert services object to array while preserving the order
  const serviceArray = [
    services.brandStrategy,
    services.experienceDesign,
    services.communicationDesign,
    services.brandConsulting
    
  ];

  return (
    <div className="cards-container">
      <div className="ulev__blog-content">
        <h1>What we Do</h1>
      </div>
      <div className="cards">
        {serviceArray.map((service, index) => (
          <div className="card-header" key={index}>
            <div className="card-content">
              <div className="card-title">{service.number}</div>
              <div className="card-description">{service.title}</div>
            </div>
            <div className="card-tasks">
              <ul>
                {service.tasks && service.tasks.map((task, taskIndex) => (
                  <li key={taskIndex}>{task}</li>
                ))}
              </ul>
            </div>
            {service.imageUrl && (
              <img 
                src={service.imageUrl} 
                alt={service.title} 
                className="card-image" 
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Available';
                }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;